import React from "react";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import PreferredProviderSearch from "./pages/PreferredProviderSearch";
import ProviderSearch from "./pages/ProviderSearch";

export default class extends React.Component {
  render() {
    return (
  
      <HashRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/home" element={<Home />} />
          <Route path="/providerSearch" element={<ProviderSearch />} />
          <Route
            path="/preferredProviderSearch"
            element={<PreferredProviderSearch />}
          />
        </Routes>
      </HashRouter>
    );
  }
}
